import type { Theme, SxProps } from "@mui/material/styles";

/**
 * Styles for Tag Colors component (color picker)
 */
export const tagColorsStyles = (
  theme: Theme,
): Record<string, SxProps<Theme>> => ({
  swatch: {
    width: "25px",
    height: "25px",
    display: "inline-block",
    margin: "2px",
    borderRadius: "4px",
    cursor: "pointer",
  },
  popover: {
    display: "flex",
    flexWrap: "wrap",
    padding: "10px",
    maxWidth: "165px",
  },
});
